var _defs, _path, _rect, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSauna(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sauna",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: .75px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.12,11.66l-.18,3.55-.17,3.22c-.03.68-.59,1.21-1.27,1.21h-6.89c-.67,0-1.23-.52-1.27-1.19l-.22-3.19-.25-3.6h10.25Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.03,
    y: 9.29,
    width: 11.95,
    height: 2.38,
    rx: 0.71,
    ry: 0.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.83,11.03h0c0,1.67-.73,3.16-1.9,4.18-.97.85-2.25,1.37-3.65,1.37h-2.58c-1.37,0-2.62-.5-3.59-1.32-1.2-1.02-1.95-2.53-1.95-4.22h0c0-.08.06-.14.13-.14h.73v.05c0,.39.32.71.71.71h10.53c.39,0,.71-.32.71-.71v-.05h.72c.07,0,.13.06.13.13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.88,4.36s-.24.43-.24.89.59.91.66,1.35c.1.56-.14,1.06-.14,1.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.07,4.36s-.24.43-.24.89.59.91.66,1.35c.1.56-.14,1.06-.14,1.06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.26,4.36s-.24.43-.24.89.59.91.66,1.35c.1.56-.14,1.06-.14,1.06"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauna);
export default __webpack_public_path__ + "static/media/sauna.9b84abe5889f8e656908e57092b10f98.svg";
export { ForwardRef as ReactComponent };